import * as S from './styles';
import { useCart } from '@/hooks';
import { SearchField } from "@/components";
import { Dispatch, InputHTMLAttributes, SetStateAction } from 'react';

interface SearchInputProps extends InputHTMLAttributes<any> {
  onBlur?: () => void;
  onFocus?: () => void;
  setInput: Dispatch<SetStateAction<string>>;
  id: string;
  value: string;
  $animate?: boolean;
}

const SearchInput = ({
  onBlur,
  onFocus,
  setInput,
  value,
  $animate,
  ...rest
}: SearchInputProps) => {

  const { setIsSearching, setFilterTerm } = useCart();
  return (
    <S.InputContainer $animate={$animate}>
       <SearchField
          onFocus={onFocus}
          value={value}
          showMicrophone={false}
          showCamera={false}
          setInput={setInput}
          {...rest}
        />
        <S.CancelButton $show={rest?.id === 'carrinho' ? true : !!value} onClick={() => {
          setFilterTerm("");
          setIsSearching(prev => !prev);
          }}>
          Cancelar
        </S.CancelButton>
    </S.InputContainer>
  )
}

export default SearchInput;